import React from "react";
import { AiTwotoneDelete } from "react-icons/ai";
import { MdLibraryAdd } from "react-icons/md";
import styles from "../../components.module.css";
import { DynamicForm } from "../../index";
import FieldHeader from "../FieldHeader";

function ArrayInput({ parameters, value, onChange, utilsData }) {
  value = value === undefined ? parameters["default"] : value;

  const handleChange = (v, i) => {
    onChange(
      value.map((x, j) => {
        if (j === i) {
          x = { ...v };
        }
        return x;
      })
    );
  };

  const handleDeletion = (i) => {
    onChange(value.filter((x, j) => j !== i));
  };

  const handleAddition = (model) => {
    const elem = {};
    Object.keys(model).forEach((x) => (elem[x] = model[x]["default"]));
    if (value) {
      onChange([...value, ...[elem]]);
    } else {
      onChange([...[elem]]);
    }
  };

  return (
    <div>
      <FieldHeader
        label={parameters.label}
        description={parameters.description}
      />
      {value &&
        value.map((x, i) => (
          <div key={i} className={styles.form_group}>
            <DynamicForm
              parametersModel={parameters["elemModel"]}
              formData={x}
              onParameterChange={(y) => handleChange(y, i)}
              utilsData={utilsData}
            />
            <div className={styles.delete_button}>
              <AiTwotoneDelete onClick={() => handleDeletion(i)} />
            </div>
          </div>
        ))}
      <MdLibraryAdd
        className={styles.add_button}
        onClick={() => handleAddition(parameters["elemModel"])}
      />
    </div>
  );
}

export default ArrayInput;
